<template>
  <ButtonView type="link" color="foreground" :route="canViewThisUser ? userRoute : undefined" :style="!canViewThisUser ? { 'pointer-events': 'none' } : {}">
    <div class="d-flex align-items-center g-2">
      <AvatarView :url="user.avatarUrl"/>
      <span class="text-start">{{ user.name }}</span>
    </div>
  </ButtonView>
</template>

<script setup>
import {ButtonView} from "@/niftybit";
import {adminRoles} from "@/systems/main/adminRoles.js";
import AvatarView from "@/components/global/AvatarView.vue";
import {computed} from "vue";
import info from "@/info";
import authorization from "@/authorization";

const props = defineProps({
  user: Object
});

const canViewThisUser = computed(() => info.user?.id === props.user.id || authorization.adminRole(adminRoles.moderator));
const userRoute = computed(() => ({ name: "user", params: { userId: props.user.id }}));

</script>